import Div from "@jumbo/shared/Div";
import {
  Card,
  CircularProgress,
  FormControlLabel,
  Grid,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { BASE_URL } from "app/services/auth-services";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { AiFillEye } from "react-icons/ai";
import LeaveDocumentApproval from "./LeaveManagement/ApplyLeave/LeaveDocumentApproval";
import LeaveCancellationDocumentApproval from "./LeaveManagement/LeaveCancellation/LeaveCancellationDocumentApproval";
import TimeManagementDocumentApproval from "./TimeManagement/TimeManagementDocumentApproval";
import AttendanceDocumentApproval from "./AttendanceManagement/AttendanceDocumentApproval";
import PayslipDocumentApproval from "./PayrollManagement/PayslipDocumentApproval";
import {
  formatIndianNumber,
  todayDate,
} from "app/shared/ReuseComponents/DateFormatter";
import SettlementDocumentApproval from "./FullandFinalSettlement/SettlementDocumentApproval";
import { ErpSaveUpdateButton } from "app/shared/ReuseComponents/ButtonComponent";
import ClaimDocumentApproval from "./Reimbursement/ClaimDocumentApproval";
import { FirstLetterCaps } from "app/shared/ReuseComponents/StyledComponents";
import ResignationDocumentApproval from "./resignation/ResignationDocumentApproval";
import DocumentApprovalForHrNew from "./DocumentApprovalForHrNew";
import { generateHRApprovalMail } from "app/utils/documentUtils";
import { fetchLeaveApprovalWorkflow } from "app/services/documentService";

const approvalValidationSchema = yup.object({
  status_btn: yup
    .string()
    .nullable("Approval is required")
    .required("Approval is required"),
  // comments: yup.string().required("Description is required"),
  // .min(10, "Approver Description must be at least 10 characters"),
});

const DocumentApprovalForHr = () => {
  const safeParseId = (val) => {
    if (val === null || val === undefined) return null;
    if (typeof val === "object") {
      return val.id ? parseInt(val.id) : null;
    }
    const parsed = parseInt(val);
    return isNaN(parsed) ? null : parsed;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isApprovalLoading, setIsApprovalLoading] = useState(false);
  const [requests, setRequests] = useState({});
  const [updateHistory, setUpdateHistory] = useState([]);

  const [approvals, setApprovals] = useState([
    {
      id: "",
      Approvername: "",
      ApproverRole: "",
      comments: "",
      status_btn: "",
      Approved_flg: false,
      status: true,
      time: "",
    },
  ]);

  const [value, setValue] = useState("1");
  const [approverName, setApproverName] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState([]);

  console.log("APProv", approvals, approvalStatus);

  // get a data from url param
  const urlParams = new URLSearchParams(window.location.search);

  const Id = urlParams.get("id");
  const idArray = Array.isArray(Id) && JSON.parse(Id.replace(/'/g, '"'));
  console.log("Id", Id, typeof Id);
  const WorkflowName = urlParams.get("Document_Type");
  const documentapprovalid = urlParams.get("documentapprovalid");
  const indexId = parseInt(urlParams.get("index"));
  const numberIndex = parseInt(urlParams.get("Comments"));
  const HeadApproverName = urlParams.get("Headname");
  const HeadApproverRole = urlParams.get("Designation");

  const [currentApproverId, setCurrentApproverId] = useState(indexId);
  console.log("currentApproverId", currentApproverId);
  const [number, setNumber] = useState(numberIndex);
  console.log("numberIndex", numberIndex, indexId, requests, approvals);

  const [employeeLists, setEmployeeLists] = useState([]);

  /* =========================
   UNIVERSAL INITIATOR EMAIL
   ========================= */

  const getInitiatorEmail = () => {
    const isBulkList = WorkflowName === "Attandance Management" || WorkflowName === "payroll management";

    // Handle array of requests
    if (Array.isArray(requests)) {
      const data = isBulkList ? requests[indexId - 1] : requests[0];

      return (
        data?.Employee_Id?.Email_Id ||
        data?.Employee_Id?.email ||
        data?.Created_By?.Email_Id ||
        data?.Created_By?.email ||
        ""
      );
    }

    // Handle single object request
    const emailFromRequests =
      requests?.Employee_Id?.Email_Id ||
      requests?.Employee_Id?.email ||
      requests?.Created_By?.Email_Id ||
      requests?.Created_By?.email;

    if (emailFromRequests) return emailFromRequests;

    // fallback
    if (
      approverName &&
      Array.isArray(approverName) &&
      currentApproverId &&
      currentApproverId <= approverName.length
    ) {
      const approver = approverName[currentApproverId - 1];
      if (approver?.Email_Id) return approver.Email_Id;
    }

    return "";
  };

  const getInitiatorName = () => {
    let firstName = "";
    let lastName = "";
    const isBulkList = WorkflowName === "Attandance Management" || WorkflowName === "payroll management";

    const data = Array.isArray(requests)
      ? (isBulkList ? requests[indexId - 1] : requests[0])
      : requests;

    // 1. Prioritize Employee_FirstName directly on the data object (confirmed correct for timesheet/leave)
    if (data?.Employee_FirstName || data?.first_name) {
      firstName = data.Employee_FirstName || data.first_name || "";
      lastName =
        data.Employee_LastName ||
        data.Employee_LasttName ||
        data.last_name ||
        "";
    }
    // 2. Try Employee_Id nested object
    else if (data?.Employee_Id && typeof data.Employee_Id === "object") {
      firstName =
        data.Employee_Id.Employee_FirstName ||
        data.Employee_Id.first_name ||
        "";

      lastName =
        data.Employee_Id.Employee_LastName ||
        data.Employee_Id.Employee_LasttName ||
        data.Employee_Id.last_name ||
        "";
    }
    // 3. Fallback to Created_By object
    else if (data?.Created_By && typeof data.Created_By === "object") {
      firstName =
        data.Created_By.Employee_FirstName ||
        data.Created_By.first_name ||
        "";

      lastName =
        data.Created_By.Employee_LastName ||
        data.Created_By.Employee_LasttName ||
        data.Created_By.last_name ||
        "";
    } else if (data?.Created_By?.id || data?.Created_By) {
      const creator = typeof data.Created_By === "object" ? data.Created_By : {};
      firstName =
        creator.Employee_FirstName ||
        creator.first_name ||
        "";

      lastName =
        creator.Employee_LastName ||
        creator.Employee_LasttName ||
        creator.last_name ||
        "";
    }

    let fullName = `${firstName} ${lastName}`.trim();
    if (fullName) return fullName;

    // 4. Fallback to approvalStatus.Initiated_By string
    if (approvalStatus?.Initiated_By) return approvalStatus.Initiated_By;

    return "Employee";
  };

  useEffect(async () => {
    if (
      WorkflowName === "Attandance Management" ||
      WorkflowName === "payroll management"
    ) {
      setIsDataLoading(true);
      await axios
        .get(
          `${BASE_URL}/Felix/HREmployeelist/?Company_Id=${(Array.isArray(requests) && requests[0]?.Company_Id) || 1}`,
        )
        .then((res) => {
          setEmployeeLists(res?.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setIsDataLoading(false));
    }
  }, [requests]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const mailContent = `
    ${WorkflowName === "Leave"
      ? `<div style="width: 100%; font-family: Arial, sans-serif;">
              Dear ${approverName[currentApproverId]?.Approvername},<br><br>
                ${getInitiatorName()} has submitted a <b>Leave request</b> for your approval.<br>
                To review and respond, <a href='{{url}}'>click here</a>.<br><br>
                Thanks and Regards,<br>${`${approverName[currentApproverId - 1]?.Approvername
      }`}<br>${approverName[currentApproverId - 1]?.ApproverRole}<br>
          </div>`
      : WorkflowName === "Leave Cancellation"
        ? `<div style="width: 100%; font-family: Arial, sans-serif;">
              Dear ${approverName[currentApproverId]?.Approvername},<br><br>
                ${getInitiatorName()} has requested to <b>cancel leave</b>.<br>
                Kindly <a href='{{url}}'>click here</a> to approve or reject the cancellation.<br><br>
                Thanks and Regards,<br>${`${approverName[currentApproverId - 1]?.Approvername
        }`}<br>${approverName[currentApproverId - 1]?.ApproverRole}<br>
          </div>`
        : WorkflowName === "timesheet" || WorkflowName === "TimesheetLog"
          ? `<div style="width: 100%; font-family: Arial, sans-serif;">
              Dear ${approverName[currentApproverId]?.Approvername},<br><br>
                ${getInitiatorName()} has submitted a <b>Timesheet</b> for your approval.<br>
                Please <a href='{{url}}'>click here</a> to review and take action.<br><br>
                Thanks and Regards,<br>${`${approverName[currentApproverId - 1]?.Approvername
          }`}<br>${approverName[currentApproverId - 1]?.ApproverRole}<br>
          </div>`
          : WorkflowName === "Full and Final Settlement"
            ? `<div style="width: 100%; font-family: Arial, sans-serif; min-height: 400px;">
                            <h4 className="mb-2 text-muted">Dear Approver,</h4>
                            <div>Please review the below document before approving.</div>
                            <br/>
                            <div style="margin-top: 16px; margin-bottom: 8px;">
                                <div style="display: flex; flex-wrap: wrap; gap: 5px;">
                                    <div style="flex: 1 1 50%; max-width: 80%;">
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Name of Employee</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Employee_Name || "N/A"
            }</p></div>
                                        </div>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Department</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Department || "N/A"
            }</p></div>
                                        </div>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Resignation Date</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Date_Of_Resignation ||
            "N/A"
            }</p></div>
                                        </div>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Relieving Date</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Releiving_Date || "N/A"
            }</p></div>
                                        </div>
                                   
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Employee Code</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Employee_Id || "N/A"
            }</p></div>
                                        </div>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Reporting To</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Reporting_To || "N/A"
            }</p></div>
                                        </div>
                                        <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                            <div style="width: 40%;"><p style="font-weight: bold;">Acceptance Date</p></div>
                                            <div style="width: 60%;"><p>: ${requests?.Acceptance_Date || "N/A"
            }</p></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse;">
                                <thead style="background-color: #f5f7fa; color: #017890;">
                                    <tr>
                                        <th style="text-align: left;">&nbsp;</th>
                                        <th style="text-align: left;">Month</th>
                                        <th style="text-align: left;">Days</th>
                                        <th style="text-align: right;">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${requests?.Salary_Details?.salaryDetails &&
              requests?.Salary_Details?.salaryDetails
                ?.length
              ? requests?.Salary_Details?.salaryDetails
                ?.map(
                  (detail) => `
                                        <tr>
                                            <td>Salary</td>
                                            <td>${detail?.month || "N/A"}</td>
                                            <td>${detail?.days || "N/A"}</td>
                                            <td style="text-align: right;">${formatIndianNumber(
                    detail?.amount,
                  ) || 0
                    }</td>
                                        </tr>
                                    `,
                )
                .join("")
              : `
                                        <tr>
                                            <td colspan="4">No Records</td>
                                        </tr>
                                    `
            }
                                    <tr>
                                        <td>Gratuity</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details?.gratuity,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td>Leave Encashment</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.leaveEncashment,
            ) || 0
            }</td>
                                    </tr>
                                    ${requests?.Salary_Details?.reimbursement &&
              Object.keys(
                requests?.Salary_Details?.reimbursement,
              ).length
              ? `
                                        <tr>
                                            <td style="font-weight: bold;">Reimbursement</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        ${Object.entries(
                requests?.Salary_Details
                  ?.reimbursement,
              )
                .map(
                  ([key, value]) => `
                                            <tr>
                                                <td>${key}</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td style="text-align: right;">${formatIndianNumber(
                    value,
                  )}</td>
                                            </tr>
                                        `,
                )
                .join("")}
                                    `
              : ""
            }
                                    <tr>
                                        <td style="font-weight: bold;">Total Earnings (A)</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.totalEarnings,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;">Provident Fund</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.providentFund,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;">Professional Tax</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.professionalTax,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;">ESI</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details?.esi,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td>Income Tax (TDS)</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details?.incomeTax,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;">Total Deductions (B)</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.totalDeductions,
            ) || 0
            }</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;">Net Settlement Dues</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td style="text-align: right;">${formatIndianNumber(
              requests?.Salary_Details
                ?.netSettlement,
            ) || 0
            }</td>
                                    </tr>
                                </tbody>
                            </table>

                            <br/>
                            <p>
                                Click the link to go to the approval page. <a href="{{url}}">Click Here</a>.
                            </p>
                            <br />
                            <p>
                                If you have any issues during the request approval or require
                                any assistance, please do not hesitate to contact us at
                                'it-support@foyer.com'.
                            </p>
                            <br />
                            <p>
                                <span><h5>Best Regards,</h5></span>
                                ${requests?.Created_By?.Employee_FirstName ||
            "N/A"
            } ${requests?.Created_By?.Employee_LasttName
            },<br/>
                                ${requests?.Created_By?.Email_Id || "N/A"},<br/>
                                ${requests?.Created_By?.Designation || "N/A"
            },<br/>
                                ${requests?.Partner_Id?.Partner_Name || "N/A"
            },<br/>
                            </p>
                        </div>`
            : WorkflowName === "Attandance Management"
              ? `<div style="width: 100%; font-family: Arial, sans-serif;">
            <div className="card-body"> 
              <h4 className="card-subtitle mb-2 text-muted">Dear ${approverName[currentApproverId]?.Approvername
              },</h4>

              <div className="card-text">
              <div>
              Attached is the <span style="font-weight: 600;">${Array.isArray(requests) && requests[0]?.Month
              }</span> employee attendance report for your review and approval.
              </div>
              <br/>
              <div>
                <p>Total Employees : ${employeeLists?.count}</p>
                <p>Total Attendance : ${requests?.length}</p>
              </div>
              <br/>
              <p>
              Click the link to go to the approval page. <a href="{{url}}">Click Here</a>.
              </p>
              <br/>
              <div>
              Your approval is required to proceed with payroll.
              </div>
              
              <br />
              <p>Best Regards,</p>
              <p>${approverName[currentApproverId - 1]?.Approvername},</p>
              <p>${approverName[currentApproverId - 1]?.ApproverRole}</p>
          </div>
        </div>`
              : `<div style="width: 100%; font-family: Arial, sans-serif;">
            <h4 className="mb-2 text-muted">Dear ${approverName[currentApproverId]?.Approvername
              },</h4>
           
            <div className="card-text">
              <div>
                Please find attached the <span style="font-weight: 600;">${Array.isArray(requests) && requests[0]?.Month
              }</span> payroll report for your review and approval.
              </div>
              <br/>
              <div>
                <p>Total Employees : ${employeeLists?.count}</p>
                <p>Processed Payrolls : ${requests?.length}</p>
              </div> 
              <br/>
              <p>
                Click the link to go to the approval page. <a href="{{url}}"> Click Here</a>.
              </p>
              <br/>
              <p>
                Your prompt approval is essential to proceed with salary disbursal.
              </p>
          
                <br />
                <p>Best Regards,</p>
                <p>${approverName[currentApproverId - 1]?.Approvername},</p>
                <p>${approverName[currentApproverId - 1]?.ApproverRole}</p>
            </div>
          </div>`
    }`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/Felix/DocumentapprovalCRUD/?Documentapproval_Id=${documentapprovalid}`,
        );
        const filterData = res?.data?.Approve;
        setApprovals(filterData);
        setApproverName(filterData);
        // setApprovalStatus(res?.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [documentapprovalid]);

  const [openViewRequest, setOpenViewRequest] = useState(false);
  const [closeRequest, setCloseRequest] = useState(false);

  const safeParseArray = (value) => {
    try {
      const parsed = JSON.parse(value.replace(/'/g, '"'));
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (!WorkflowName || !Id) return;

    let isMounted = true; // prevents state update after unmount

    const fetchData = async () => {
      setIsDataLoading(true);

      try {
        let response = null;
        const idArray = safeParseArray(Id);
        const isBulk = Array.isArray(idArray);

        switch (WorkflowName) {
          case "Leave":
            response = await axios.get(`${BASE_URL}/Felix/Getleave/?id=${Id}`);
            break;

          case "Leave Cancellation":
            response = await axios.get(
              `${BASE_URL}/Felix/LeavecancellationwithouttokenCRUD/?id=${Id}`,
            );
            break;

          case "timesheet":
            response = await axios.get(
              `${BASE_URL}/Felix/TimeSheetwithoutCRUD/?id=${Id}`,
            );
            break;

          case "TimesheetLog":
            response = isBulk
              ? await axios.post(`${BASE_URL}/Felix/ListOfTimesheetsGetById/`, {
                ids: idArray,
              })
              : await axios.get(
                `${BASE_URL}/Felix/TimeSheetwithoutCRUD/?id=${Id}`,
              );
            break;

          case "Reimbursement":
            response = await axios.get(
              `${BASE_URL}/Felix/EmployeeClaimGetById/?id=${Id}`,
            );
            break;

          case "Full and Final Settlement":
            response = await axios.get(
              `${BASE_URL}/Felix/FullandFinalCRUD/?id=${Id}`,
            );
            break;

          case "Resignation":
            response = await axios.get(
              `${BASE_URL}/Felix/EmployeeResignationGet/?id=${Id}`,
            );
            break;

          case "Attandance Management":
            response = isBulk
              ? await axios.post(`${BASE_URL}/Felix/ListOfAttandanceGetById/`, {
                ids: idArray,
              })
              : await axios.get(
                `${BASE_URL}/Felix/Attandancemasterget/?id=${Id}`,
              );
            break;

          case "payroll management":
            response = isBulk
              ? await axios.post(`${BASE_URL}/Felix/ListOfPayslipGetById/`, {
                ids: idArray,
              })
              : await axios.get(
                `${BASE_URL}/Felix/PayslipwithoutCRUD/?id=${Id}`,
              );
            break;

          default:
            return;
        }

        if (isMounted && response?.data) {
          // Handle paginated & non-paginated responses
          const data = response.data?.results ?? response.data;

          console.log("RequestNEW", data);
          setRequests(data);
        }
      } catch (error) {
        console.error("FetchData Error:", error);
      } finally {
        if (isMounted) setIsDataLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [WorkflowName, Id]);

  const sendNotification = useCallback((payload) => {
    axios
      .post(`${BASE_URL}/Felix/Notificationscrudwithoutpagination/`, payload)
      .then((res) => {
        console.log("PP", res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const getRequests = async () => {
      setIsApprovalLoading(true);
      try {
        let endpoint = "";

        if (WorkflowName === "Leave" && requests?.Application_Id) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.Application_Id}`;
        } else if (
          WorkflowName === "Leave Cancellation" &&
          requests?.Cancellation_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.Cancellation_Id}`;
        } else if (WorkflowName === "timesheet" && requests?.TimeSheet_Id) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.TimeSheet_Id}`;
        } else if (
          WorkflowName === "Reimbursement" &&
          requests?.Employeeclaim_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.Employeeclaim_Id}`;
        } else if (
          WorkflowName === "Attandance Management" &&
          Array.isArray(requests) &&
          requests[0]?.Attandancemaster_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${Array.isArray(requests) && requests[0]?.Attandancemaster_Id}`;
        } else if (
          WorkflowName === "payroll management" &&
          Array.isArray(requests) &&
          requests[0]?.Payslip_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${Array.isArray(requests) && requests[0]?.Payslip_Id}`;
        } else if (
          WorkflowName === "Full and Final Settlement" &&
          requests?.FullandFinal_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.FullandFinal_Id}`;
        } else if (
          WorkflowName === "Resignation" &&
          requests?.EmployeeResignation_Id
        ) {
          endpoint = `/Felix/Materialrequestworkflow/?Request_Id=${requests?.EmployeeResignation_Id}`;
        } else {
          console.log("WorkflowName", WorkflowName);
          return;
        }

        await axios
          .get(`${BASE_URL}${endpoint}`)
          .then((res) => {
            console.log("RESSSsssssss", res?.data);
            setApprovalStatus(res?.data[0]);
            if (number !== 0) {
              setApprovals(res?.data[0]?.Approve);
              setApproverName(res?.data[0]?.Approve);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      } finally {
        setIsApprovalLoading(false);
      }
    };
    if (
      WorkflowName === "Attandance Management" ||
      WorkflowName === "payroll management"
    ) {
      getRequests();
    } else {
      if (Object.keys(requests).length !== 0) {
        getRequests();
      }
    }
  }, [requests, WorkflowName, number, setApprovalStatus, setApprovals]);

  useEffect(() => {
    const fetchDynamicApproverList = async () => {
      const initiatorId =
        requests?.Employee_Id?.id ||
        requests?.Employee_Id ||
        requests?.Created_By?.id ||
        requests?.Created_By ||
        requests?.Application_Id?.Employee_Id?.id ||
        requests?.Application_Id?.Employee_Id;
      if (
        (WorkflowName === "Leave" ||
          WorkflowName === "timesheet" ||
          WorkflowName === "Leave Cancellation") &&
        initiatorId &&
        number === 0
      ) {
        setIsApprovalLoading(true);
        try {
          const res = await fetchLeaveApprovalWorkflow(initiatorId);
          const filterData = res?.Approve;
          if (filterData && filterData.length > 0) {
            setApprovals(filterData);
            setApproverName(filterData);
          }
        } catch (error) {
          console.error("Error fetching dynamic approvers:", error);
        } finally {
          setIsApprovalLoading(false);
        }
      }
    };
    fetchDynamicApproverList();
  }, [requests, WorkflowName, number]);

  const handleChangeApproverCommentRequest = (e, index) => {
    const { name, value } = e.target;

    const list = [...approvals];
    console.log("List2", list);
    if (index === number) {
      list[index][name] = value;
      if (list[index].status_btn === "yes") {
        list[index].status = true;
        list[index].Approved_flg = true;
        list[index].comments = e.target.value;
        list[index].time = new Date().toJSON();
        console.log("LIST@1", list);
        setApprovals(list);
        // console.log("list1", list);
      } else if (list[index].status_btn === "no") {
        list[index].status = true;
        list[index].Approved_flg = false;
        list[index].comments = e.target.value;
        list[index].time = new Date().toJSON();
        setApprovals(list);
      } else {
        list[index].status = false;
        list[index].Approved_flg = false;
        list[index].comments = e.target.value;
        list[index].time = new Date().toJSON();
        setApprovals(list);
        // console.log("list2", list);
      }
    }
  };

  const handleChangeApproverRequest = (e, index) => {
    // getApproversData();
    const { name, value } = e.target;

    const list = [...approvals];
    console.log("List2", list);
    if (index === number) {
      list[index][name] = value;
      if (list[index].status_btn === "yes") {
        list[index].status = true;
        list[index].Approved_flg = true;
        //list[index].comments = e.target.value;
        console.log("LIST@1", list);
        setApprovals(list);
        // console.log("list1", list);
      } else if (list[index].status_btn === "no") {
        list[index].status = true;
        list[index].Approved_flg = false;
        //list[index].comments = e.target.value;
        setApprovals(list);
      } else {
        list[index].comments = e.target.value;
        list[index].status = false;
        list[index].Approved_flg = false;
        setApprovals(list);
        // console.log("list2", list);
      }
    }
  };

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(approvalValidationSchema),
  });

  const handleApproveRequest = async (e) => {
    e.preventDefault();

    let listsdata = [...approvals];
    // listsdata[number].OneTimeApproved_flg = true;
    // setApprovals(listsdata);

    console.log(approvals);
    if (
      approvals[number].status_btn == null ||
      approvals[number].status_btn == "" ||
      approvals[number].status_btn == undefined
    ) {
      toast.error("Approval is required");
      return false;
    }
    if (
      approvals[number].comments == null ||
      approvals[number].comments == "" ||
      approvals[number].comments == undefined
    ) {
      toast.error("Description is required");
      return false;
    }
    if (approvals[number].comments.length < 5) {
      toast.error("Approver Description must be at least 5 characters");
      return false;
    }

    try {
      setIsLoading(true);
      approvals[number].OneTimeApproved_flg = true;
      listsdata[number].OneTimeApproved_flg = true;
      setApprovals(listsdata);

      if (WorkflowName === "Leave") {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.Application_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Leave",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              if (currentApproverId === approverName?.length) {
                var payload = {
                  ...requests,
                  Approved_Flag: true,
                  Status: true,
                  Leave_flg: "Approved",
                  Sanctioned_Date: new Date().toISOString().substring(0, 10),
                  Sancleavefrom_Date: new Date().toISOString().substring(0, 10),
                  Sancleaveto_Date: new Date().toISOString().substring(0, 10),
                  Leavetype_Id: parseInt(requests?.Leavetype_Id?.id),
                  Employee_Id: parseInt(requests?.Employee_Id?.id),
                  Approved_By: parseInt(requests?.Updated_By?.id || requests?.Created_By?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Updated_By: parseInt(requests?.Updated_By?.id || requests?.Created_By?.id),
                };
                axios
                  .put(`${BASE_URL}/Felix/updateleave/`, payload)
                  .then(async (res) => {
                    console.log(res);
                    if (res.status === 200 && res?.data?.id) {
                      toast.success("Leave has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: approverName[currentApproverId - 1],
                          requests: requests,
                        });
                        const response = await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: approverName[currentApproverId - 1]?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                        console.log(response);
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      // // update the leave balance
                      // hrApiServices.listofLeaveTaken(requests?.Company_Id?.id, requests?.Partner_Id?.id, requests?.id, requests?.Year).then((res) => {
                      //   console.log(res);
                      // }).catch((error) => {
                      //   console.log(error);
                      // });

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Leave No ${requests?.Application_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Company_Id?.id),
                      };
                      sendNotification(payload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Leave No ${requests?.Application_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              var payload = {
                ...requests,
                Approved_Flag: false,
                Status: true,
                Leave_flg: "Rejected",
                Sanctioned_Date: new Date().toISOString().substring(0, 10),
                Sancleavefrom_Date: new Date().toISOString().substring(0, 10),
                Sancleaveto_Date: new Date().toISOString().substring(0, 10),
                Leavetype_Id: parseInt(requests?.Leavetype_Id?.id),
                Employee_Id: parseInt(requests?.Employee_Id?.id),
                Approved_By: parseInt(requests?.Updated_By?.id || requests?.Created_By?.id),
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Updated_By?.id || requests?.Created_By?.id),
              };
              axios
                .put(`${BASE_URL}/Felix/updateleave/`, payload)
                .then(async (res) => {
                  console.log(res);
                  if (res.status === 200 && res.data.id) {
                    toast.success("Leave has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Leave No ${requests?.Application_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Company_Id?.id),
                    };
                    sendNotification(payload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else if (WorkflowName === "Leave Cancellation") {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.Cancellation_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Leave Cancellation",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              if (currentApproverId === approverName?.length) {
                var payload = {
                  Leave_Id: parseInt(requests?.Application_Id?.id),
                  LeaveCancel_Id: parseInt(requests?.id),
                };
                axios
                  .post(`${BASE_URL}/Felix/ApproveLeaveCancellation/`, payload)
                  .then(async (res) => {
                    console.log(res);
                    if (res.status === 200 && res.data.id) {
                      toast.success("Leave Cancellation has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: approverName[currentApproverId - 1],
                          requests: requests,
                        });
                        const response = await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: approverName[currentApproverId - 1]?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                        console.log(response);
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Leave Cancellation No ${requests?.Cancellation_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Company_Id?.id),
                      };
                      sendNotification(payload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Leave Cancellation No ${requests?.Cancellation_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              var payload = {
                ...requests,
                Leavecancel_flg: false,
                Status: true,
                Leave_flg: "Rejected",
                Application_Id: parseInt(requests?.Application_Id?.id),
                Leavetype_Id: parseInt(requests?.Leavetype_Id?.id),
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Created_By?.id),
              };
              axios
                .put(
                  `${BASE_URL}/Felix/LeavecancellationwithouttokenCRUD/`,
                  payload,
                )
                .then(async (res) => {
                  console.log(res);
                  if (res?.data?.id) {
                    toast.success("Leave Cancellation has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Leave Cancellation No ${requests?.Cancellation_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Company_Id?.id),
                    };
                    sendNotification(payload);
                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else if (WorkflowName === "timesheet") {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.TimeSheet_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Timesheet",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              if (currentApproverId === approverName?.length) {
                var payload = {
                  ...requests,
                  Approved_Flag: true,
                  Status: true,
                  Timesheet_flg: "Approved",
                  Employee_Id: parseInt(requests?.Employee_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Updated_By: parseInt(requests?.Updated_By?.id),
                };
                axios
                  .put(`${BASE_URL}/Felix/TimeSheetwithoutCRUD/`, payload)
                  .then(async (res) => {
                    console.log(res);
                    if (res.status === 200 && res.data.id) {
                      toast.success("Timesheet has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: approverName[currentApproverId - 1],
                          requests: requests,
                        });
                        const response = await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: approverName[currentApproverId - 1]?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                        console.log(response);
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Timesheet No ${requests?.TimeSheet_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Company_Id?.id),
                      };
                      sendNotification(payload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Timesheet No ${requests?.TimeSheet_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              var payload = {
                ...requests,
                Approved_Flag: false,
                Status: true,
                Timesheet_flg: "Rejected",
                Employee_Id: parseInt(requests?.Employee_Id?.id),
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Updated_By?.id),
              };
              axios
                .put(`${BASE_URL}/Felix/TimeSheetwithoutCRUD/`, payload)
                .then(async (res) => {
                  console.log(res);
                  if (res.status === 200 && res.data.id) {
                    toast.success("Timesheet has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Timesheet No ${requests?.TimeSheet_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Company_Id?.id),
                    };
                    sendNotification(payload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else if (WorkflowName === "Reimbursement") {
        setIsLoading(true);
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.Employeeclaim_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Reimbursement",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res?.data?.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              if (currentApproverId === approverName?.length) {
                let filteredRequests = { ...requests };
                const keysToRemove = ["Claim_Attachment"];

                // Remove those keys
                keysToRemove.forEach((key) => delete filteredRequests[key]);

                var payload = {
                  ...filteredRequests,
                  Reimbursement_Id: requests?.Reimbursement_Id?.id,
                  Approved_Flag: true,
                  Status: true,
                  Claim_Date:
                    requests?.Claim_Date !== null
                      ? requests?.Claim_Date
                      : todayDate,
                  Claim_Status: "Approved",
                  Claim_Attachment_Name: "",
                  Employee_Id: parseInt(requests?.Employee_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Updated_By: parseInt(requests?.Updated_By?.id),
                };
                axios
                  .patch(`${BASE_URL}/Felix/EmployeeclaimsCRUD/`, payload)
                  .then(async (res) => {
                    console.log(res);
                    if (res?.data?.id) {
                      toast.success("Claim has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: approverName[currentApproverId - 1],
                          requests: requests,
                        });
                        const response = await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: approverName[currentApproverId - 1]?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                        console.log(response);
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Claim No ${requests?.Employeeclaim_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Created_By?.Company_Id),
                      };
                      sendNotification(payload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Claim No ${requests?.Employeeclaim_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              let filteredRequests = { ...requests };
              const keysToRemove = ["Claim_Attachment"];

              // Remove those keys
              keysToRemove.forEach((key) => delete filteredRequests[key]);

              var payload = {
                ...filteredRequests,
                Reimbursement_Id: requests?.Reimbursement_Id?.id,
                Approved_Flag: false,
                Status: true,
                Claim_Date:
                  requests?.Claim_Date !== null
                    ? requests?.Claim_Date
                    : todayDate,
                Claim_Status: "Rejected",
                Employee_Id: parseInt(requests?.Employee_Id?.id),
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Updated_By?.id),
              };
              axios
                .patch(`${BASE_URL}/Felix/EmployeeclaimsCRUD/`, payload)
                .then(async (res) => {
                  console.log(res);
                  if (res?.data?.id) {
                    toast.success("Reimbursement has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    console.log(
                      "APPROVER NAME",
                      approverName[currentApproverId - 1]?.Approvername,
                    );
                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Claim No ${requests?.Employeeclaim_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Created_By?.Company_Id),
                    };
                    sendNotification(payload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else if (WorkflowName === "Full and Final Settlement") {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.FullandFinal_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Full and Final Settlement",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              // send approval mail to initiator
              try {
                const mailHTML = generateHRApprovalMail({
                  workflowName: FirstLetterCaps(WorkflowName),
                  latestApproval: approverName[currentApproverId - 1],
                  requests: requests,
                });
                const response = await axios.post(
                  `${BASE_URL}/Felix/Approvalrejectmail/`,
                  {
                    MailId: getInitiatorEmail(),
                    ApproverId: approverName[currentApproverId - 1]?.id,
                    mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                    mailhtml: mailHTML,
                  },
                );
                console.log(response);
              } catch (err) {
                console.log("Error in sending mail", err);
              }

              if (currentApproverId === approverName?.length) {
                var payload = {
                  ...requests,
                  Approved_Flg: true,
                  Status: true,
                  Company_Id: parseInt(requests?.Company_Id?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Updated_By: parseInt(requests?.Updated_By?.id),
                };
                axios
                  .put(`${BASE_URL}/Felix/FullandFinalCRUD/`, payload)
                  .then(async (res) => {
                    console.log(res);
                    if (res?.data?.id) {
                      toast.success(
                        "Full and Final Settlement has been Approved",
                      );
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Full and Final Settlement No ${requests?.FullandFinal_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Company_Id?.id),
                      };
                      sendNotification(payload);

                      // change the resignation flag in employee module
                      if (requests?.Employee_Id) {
                        await axios
                          .get(
                            `${BASE_URL}/Felix/EmployeeCRUDwithouttoken/?Employee_Id=${requests?.Employee_Id}`,
                          )
                          .then(async (res) => {
                            fetch(`${BASE_URL}${res?.data?.Employee_Photo}`)
                              .then(async (response) => response.arrayBuffer())
                              .then(async (buffer) => {
                                const base64 = btoa(
                                  new Uint8Array(buffer).reduce(
                                    (data, byte) =>
                                      data + String.fromCharCode(byte),
                                    "",
                                  ),
                                );
                                const urlParts =
                                  res?.data.Employee_Photo.split("/");

                                if (res?.data) {
                                  var payload = {
                                    ...res?.data,
                                    Resigned_Flg: true,
                                    Releive_Date: requests?.Releiving_Date,
                                    Employee_Photo: base64,
                                    Employee_Photo_Name:
                                      urlParts[urlParts.length - 1],
                                    Company_Id: res?.data?.Company_Id?.id,
                                    Created_By: res?.data?.Created_By?.id,
                                    Updated_By: res?.data?.Updated_By?.id,
                                  };
                                  await axios
                                    .put(
                                      `${BASE_URL}/Felix/EmployeeCRUDwithouttoken/`,
                                      payload,
                                    )
                                    .then(async (res) => {
                                      console.log(res);
                                    })
                                    .catch((error) => {
                                      console.log(error);
                                    });
                                }
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      }

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Full and Final Settlement No ${requests?.FullandFinal_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              var payload = {
                ...requests,
                Approved_Flg: false,
                Status: true,
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Updated_By?.id),
              };
              axios
                .put(`${BASE_URL}/Felix/FullandFinalCRUD/`, payload)
                .then(async (res) => {
                  console.log(res);
                  if (res.status === 200 && res.data.id) {
                    toast.success(
                      "Full and Final Settlement has been Rejected",
                    );
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Full and Final Settlement No ${requests?.FullandFinal_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Company_Id?.id),
                    };
                    sendNotification(payload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else if (WorkflowName === "Resignation") {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests?.EmployeeResignation_Id,
          Created_By: requests?.Created_By?.id,
          Updated_By: requests?.Updated_By?.id,
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Resignation",
        };

        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              if (currentApproverId === approverName?.length) {
                // ✅ Final approver reached — mark resignation as approved
                var payload = {
                  ...requests,
                  Approved_Flag: true,
                  Status: true,
                  Resignation_flg: "Approved",
                  Resign_Date: new Date().toISOString().substring(0, 10),
                  Relieving_Date: new Date().toISOString().substring(0, 10),
                  Employee_Id: parseInt(requests?.Employee_Id?.id),
                  Approved_By: parseInt(requests?.Updated_By?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Updated_By: parseInt(requests?.Updated_By?.id),
                };

                axios
                  .put(`${BASE_URL}/Felix/EmployeeResignationCRUD/`, payload)
                  .then(async (res) => {
                    if (res.status === 200 && res?.data?.id) {
                      toast.success("Resignation has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: approverName[currentApproverId - 1],
                          requests: requests,
                        });
                        const response = await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: approverName[currentApproverId - 1]?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                        console.log(response);
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      // ✅ Send notification to initiator
                      var notifPayload = {
                        Notification_Msg: `Resignation No ${requests?.EmployeeResignation_Id} is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(requests?.Created_By?.id),
                        Partner_Id: parseInt(requests?.Partner_Id?.id),
                        Company_Id: parseInt(requests?.Company_Id?.id),
                      };
                      sendNotification(notifPayload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                // ✅ Move to next approver
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                var notifPayload = {
                  Notification_Msg: `Resignation No ${requests?.EmployeeResignation_Id} is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests?.Created_By?.id),
                  Partner_Id: parseInt(requests?.Partner_Id?.id),
                  Company_Id: parseInt(requests?.Company_Id?.id),
                };
                sendNotification(notifPayload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              // ❌ Rejected case
              var payload = {
                ...requests,
                Approved_Flag: false,
                Status: true,
                Resignation_flg: "Rejected",
                Resign_Date: new Date().toISOString().substring(0, 10),
                Relieving_Date: new Date().toISOString().substring(0, 10),
                Employee_Id: parseInt(requests?.Employee_Id?.id),
                Approved_By: parseInt(requests?.Updated_By?.id),
                Company_Id: parseInt(requests?.Company_Id?.id),
                Partner_Id: parseInt(requests?.Partner_Id?.id),
                Created_By: parseInt(requests?.Created_By?.id),
                Updated_By: parseInt(requests?.Created_By?.id),
              };

              axios
                .put(`${BASE_URL}/Felix/EmployeeResignationCRUD/`, payload)
                .then(async (res) => {
                  if (res.status === 200 && res.data.id) {
                    toast.success("Resignation has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // ✅ Send notification
                    var notifPayload = {
                      Notification_Msg: `Resignation No ${requests?.Application_Id} is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(requests?.Created_By?.id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id),
                      Company_Id: parseInt(requests?.Company_Id?.id),
                    };
                    sendNotification(notifPayload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("Error in resignation workflow", error);
          });
      } else if (WorkflowName === "Attandance Management") {
        try {
          const payload = {
            Documentapproval_Id: documentapprovalid,
            Request_Id: requests[indexId - 1].Attandancemaster_Id,
            Created_By: parseInt(requests[indexId - 1]?.Created_By?.id),
            Updated_By: parseInt(requests[indexId - 1]?.Created_By?.id),
            Approval_Id: approvals,
            Approve: approvals,
            Request_Key: requests[indexId - 1]?.id,
            Request_Name: "Attandance Management",
          };

          const response = await axios.put(
            `${BASE_URL}/Felix/DocumentapprovalCRUD/`,
            payload,
          );

          if (response.data.id && approvals[number]?.Approved_flg === true) {
            toast.success("Approved Successfully");

            if (currentApproverId === approverName?.length) {
              const flagPayload = {
                Attandancemasterid: JSON.parse(Id.replace(/'/g, '"')),
                Approved_Flag: true,
                Status: approvals[number].status_btn === "yes",
                Filter_status: "Approved",
                Updated_By: parseInt(
                  requests[indexId - 1]?.Created_By?.id
                    ? requests[indexId - 1]?.Created_By?.id
                    : requests[indexId - 1]?.Updated_By,
                ),
              };

              try {
                const flagResponse = await axios.put(
                  `${BASE_URL}/Felix/Attandancemasterflagchange/`,
                  flagPayload,
                );

                if (flagResponse.status === 200) {
                  toast.success("Attendance has been Approved");

                  setCurrentApproverId(currentApproverId);
                  setNumber(number);

                  // send approval mail to initiator
                  try {
                    const mailHTML = generateHRApprovalMail({
                      workflowName: FirstLetterCaps(WorkflowName),
                      latestApproval: approverName[currentApproverId - 1],
                      requests: requests,
                    });
                    const response = await axios.post(
                      `${BASE_URL}/Felix/Approvalrejectmail/`,
                      {
                        MailId: getInitiatorEmail(),
                        ApproverId: approverName[currentApproverId - 1]?.id,
                        mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                        mailhtml: mailHTML,
                      },
                    );
                    console.log(response);
                  } catch (err) {
                    console.log("Error in sending mail", err);
                  }

                  const notificationPayload = {
                    Notification_Msg: `Employee No ${requests[indexId - 1].Employee_Id
                      } is approved by ${approverName[number]?.Approvername}`,
                    Open_flg: false,
                    User_Id: parseInt(approverName[number]?.id),
                    Created_By: parseInt(requests[indexId - 1].Created_By?.id),
                    Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                    Company_Id: parseInt(requests[indexId - 1].Company_Id?.id),
                  };

                  sendNotification(notificationPayload);

                  setTimeout(() => {
                    window.close();
                  }, 1000);
                }
              } catch (error) {
                console.error("Flag change failed:", error);
              }
            } else {
              await RequestSendForNextApprover(response);
              setCurrentApproverId(currentApproverId + 1);
              setNumber(number + 1);

              const notificationPayload = {
                Notification_Msg: `Employee No ${requests[indexId - 1].Employee_Id
                  } is approved by ${approverName[number]?.Approvername}`,
                Open_flg: false,
                User_Id: parseInt(approverName[number]?.id),
                Created_By: parseInt(requests[indexId - 1].Created_By?.id),
                Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                Company_Id: parseInt(requests[indexId - 1].Company_Id?.id),
              };

              sendNotification(notificationPayload);

              setTimeout(() => {
                window.close();
              }, 1000);
            }
          } else {
            const rejectPayload = {
              Attandancemasterid: JSON.parse(Id.replace(/'/g, '"')),
              Approved_Flag: false,
              Status: approvals[number].status_btn === "yes",
              Filter_status: "Rejected",
              Updated_By: parseInt(requests[indexId - 1]?.Created_By?.id),
            };

            try {
              const rejectResponse = await axios.put(
                `${BASE_URL}/Felix/Attandancemasterflagchange/`,
                rejectPayload,
              );

              if (rejectResponse.status === 200) {
                toast.success("Attendance has been Rejected");

                setCurrentApproverId(currentApproverId);
                setNumber(number);

                // send approval mail to initiator
                try {
                  const mailHTML = generateHRApprovalMail({
                    workflowName: FirstLetterCaps(WorkflowName),
                    latestApproval: approverName[currentApproverId - 1],
                    requests: requests,
                  });

                  const response = await axios.post(
                    `${BASE_URL}/Felix/Approvalrejectmail/`,
                    {
                      MailId: getInitiatorEmail() || "",
                      ApproverId: approverName[currentApproverId - 1]?.id,
                      mailsubject: "Re: Attandance Approval",
                      mailhtml: mailHTML,
                      //     mailhtml: `<div>
                      //   <p> Dear ${getInitiatorName()},</p>
                      //   <p> Your request has rejected by ${
                      //     approverName[currentApproverId - 1]?.Approvername
                      //   }. </p>
                      //   <p><b>Reason for Rejection:</b> ${
                      //     approverName[currentApproverId - 1]?.comments
                      //   }</p>

                      //   <p> Regards,</p>
                      //   <p> ${
                      //     approverName[currentApproverId - 1]?.Approvername
                      //   } </p>
                      // </div>`,
                    },
                  );
                  console.log(response);
                } catch (err) {
                  console.log("Error in sending mail", err);
                }

                const notificationPayload = {
                  Notification_Msg: `Employee No ${requests[indexId - 1].Employee_Id
                    } is rejected by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests[indexId - 1].Created_By?.id),
                  Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                  Company_Id: parseInt(requests[indexId - 1].Company_Id?.id),
                };

                sendNotification(notificationPayload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } catch (error) {
              console.error("Flag change (reject) failed:", error);
            }
          }
        } catch (error) {
          console.error("Document approval failed:", error);
        }
      } else {
        var payload = {
          Documentapproval_Id: documentapprovalid,
          Request_Id: requests[indexId - 1]?.Payslip_Id,
          Created_By: parseInt(requests[indexId - 1]?.Created_By?.id),
          Updated_By: parseInt(requests[indexId - 1]?.Created_By?.id),
          Approval_Id: approvals,
          Approve: approvals,
          Request_Key: requests?.id,
          Request_Name: "Payslip",
        };
        axios
          .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/`, payload)
          .then(async (res) => {
            if (res.data.id && approvals[number]?.Approved_flg === true) {
              toast.success("Approved Successfully");

              // send approval mail to initiator
              try {
                const mailHTML = generateHRApprovalMail({
                  workflowName: FirstLetterCaps(WorkflowName),
                  latestApproval: approverName[currentApproverId - 1],
                  requests: requests,
                });
                const response = await axios.post(
                  `${BASE_URL}/Felix/Approvalrejectmail/`,
                  {
                    MailId: getInitiatorEmail(),
                    ApproverId: approverName[currentApproverId - 1]?.id,
                    mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                    mailhtml: mailHTML,
                  },
                );
                console.log(response);
              } catch (err) {
                console.log("Error in sending mail", err);
              }

              if (currentApproverId === approverName?.length) {
                var payload = {
                  Payslipheaderid: JSON.parse(Id.replace(/'/g, '"')),
                  Approved_Flag: true,
                  Status: approvals[number].status_btn === "yes" ? true : false,
                  Updated_By: parseInt(requests[indexId - 1]?.Created_By?.id),
                };
                axios
                  .put(`${BASE_URL}/Felix/Payslipheaderflagchange/`, payload)
                  .then((res) => {
                    console.log(res);
                    if (res.status === 200) {
                      toast.success("Payslip has been Approved");
                      setCurrentApproverId(currentApproverId);
                      setNumber(number);

                      // notification is go for the initiator
                      var payload = {
                        Notification_Msg: `Payslip No ${requests[indexId - 1].Payslip_Id
                          } is approved by ${approverName[number]?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(approverName[number]?.id),
                        Created_By: parseInt(
                          requests[indexId - 1].Created_By?.id,
                        ),
                        Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                        Company_Id: parseInt(
                          requests[indexId - 1].Company_Id?.id,
                        ),
                      };
                      sendNotification(payload);

                      setTimeout(() => {
                        window.close();
                      }, 1000);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                await RequestSendForNextApprover(res);
                setCurrentApproverId(currentApproverId + 1);
                setNumber(number + 1);

                // notification is go for the initiator
                var payload = {
                  Notification_Msg: `Payslip No ${requests[indexId - 1].Payslip_Id
                    } is approved by ${approverName[number]?.Approvername}`,
                  Open_flg: false,
                  User_Id: parseInt(approverName[number]?.id),
                  Created_By: parseInt(requests[indexId - 1].Created_By?.id),
                  Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                  Company_Id: parseInt(requests[indexId - 1].Company_Id?.id),
                };
                sendNotification(payload);

                setTimeout(() => {
                  window.close();
                }, 1000);
              }
            } else {
              var payload = {
                Payslipheaderid: JSON.parse(Id.replace(/'/g, '"')),
                Approved_Flag: false,
                Status: approvals[number].status_btn === "yes" ? true : false,
                Updated_By: parseInt(requests[indexId - 1]?.Created_By?.id),
              };
              axios
                .put(`${BASE_URL}/Felix/Payslipheaderflagchange/`, payload)
                .then(async (res) => {
                  console.log(res);
                  if (res.status === 200) {
                    toast.success("Payslip has been Rejected");
                    setCurrentApproverId(currentApproverId);
                    setNumber(number);

                    // send approval mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: approverName[currentApproverId - 1],
                        requests: requests,
                      });
                      const response = await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: approverName[currentApproverId - 1]?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                      console.log(response);
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    // notification is go for the initiator
                    var payload = {
                      Notification_Msg: `Payslip No ${requests[indexId - 1].Payslip_Id
                        } is rejected by ${approverName[number]?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(approverName[number]?.id),
                      Created_By: parseInt(
                        requests[indexId - 1].Created_By?.id,
                      ),
                      Partner_Id: parseInt(requests[indexId - 1].Partner_Id),
                      Company_Id: parseInt(
                        requests[indexId - 1].Company_Id?.id,
                      ),
                    };
                    sendNotification(payload);

                    setTimeout(() => {
                      window.close();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    } catch (error) {
      console.log("error", error);
      listsdata[number].OneTimeApproved_flg = false;
      setApprovals(listsdata);
    } finally {
      setIsLoading(false);
    }
  };

  const RequestSendForNextApprover = async (res) => {
    console.log("requests", requests);
    try {
      var payload = {
        mailhtml: mailContent,
        Created_By:
          Array.isArray(requests)
            ? (requests[0]?.Created_By?.id || requests[0]?.Created_By)
            : (requests?.Created_By?.id || requests?.Created_By),
        mailsubject:
          WorkflowName === "Leave"
            ? "Leave Approval Request"
            : WorkflowName === "Leave Cancellation"
              ? "Leave Cancellation Approval Request"
              : WorkflowName === "timesheet"
                ? "Timesheet Approval Request"
                : WorkflowName === "Attandance Management"
                  ? "Attendance Report For Approval"
                  : WorkflowName === "payroll management"
                    ? "Payroll Approval Request"
                    : "Full and Final Settlement Request",
        approver_name: approverName[currentApproverId]?.Approvername,
        Approverid: approverName[currentApproverId]?.id,
        PreviousApproverid: approverName[currentApproverId - 1]?.id,
        Document_Type: WorkflowName,
        id:
          WorkflowName === "Attandance Management"
            ? idArray
            : WorkflowName === "payroll management"
              ? idArray
              : parseInt(Id),
        Comments: String(number + 1),
        documentapprovalid: res?.data?.Documentapproval_Id || "",
        index: parseInt(currentApproverId + 1),
        Initiated_By:
          WorkflowName === "Attandance Management"
            ? Array.isArray(requests) && requests[0].EmployeeName
            : WorkflowName === "payroll management"
              ? `${(Array.isArray(requests) && requests[0].Created_By?.first_name) || ""} ${(Array.isArray(requests) && requests[0].Created_By?.last_name) || ""}`.trim()
              : getInitiatorName(),
        Employee_Id: "",
        Designation: HeadApproverRole || "",
        first_name: HeadApproverName || "",
        Headname: HeadApproverName || "",
        Url: ``,
        total_employees: employeeLists?.count,
        processed_payroll: requests?.length,
        process_month: Array.isArray(requests) && requests[0]?.Month,
      };

      const hrResponse = await axios.post(`${BASE_URL}/Felix/HRApprovalsystem/`, payload);
      console.log("Send", hrResponse);

      // SEND PUSH NOTIFICATION FOR NEXT APPROVER (LEAVE, TIMESHEET, & LEAVE CANCELLATION)
      if (
        WorkflowName === "Leave" ||
        WorkflowName === "timesheet" ||
        WorkflowName === "Leave Cancellation"
      ) {
        try {
          await axios.post(`${BASE_URL}/Felix/SendPushNotificationView/`, {
            User_Id: payload.Approverid,
            Title:
              WorkflowName === "Leave"
                ? "Leave Approval Request"
                : WorkflowName === "timesheet"
                  ? "Timesheet Approval Request"
                  : "Leave Cancellation Approval Request",
            Body:
              WorkflowName === "Leave"
                ? `You have a new leave approval request from ${getInitiatorName()}`
                : WorkflowName === "timesheet"
                  ? `You have a new timesheet approval request from ${getInitiatorName()}`
                  : `You have a new leave cancellation approval request from ${getInitiatorName()}`,
          });
          console.log("Push notification sent for next approver");
        } catch (err) {
          console.log("Push notification error", err);
        }
      }

      // send approval mail to initiator
      try {
        const mailHTML = generateHRApprovalMail({
          workflowName: FirstLetterCaps(WorkflowName),
          latestApproval: approverName[currentApproverId - 1],
          requests: requests,
          isFinal: false,
        });
        const response = await axios.post(
          `${BASE_URL}/Felix/Approvalrejectmail/`,
          {
            MailId: getInitiatorEmail(),
            ApproverId: approverName[currentApproverId - 1]?.id,
            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
            mailhtml: mailHTML,
          },
        );
        console.log(response);
      } catch (err) {
        console.log("Error in sending mail", err);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  if (Id == "None" || !Id) {
    return (
      <Div
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "1.25rem",
          color: "error.main",
          fontWeight: "medium",
          textAlign: "center",
          p: 2,
          borderRadius: 2,
          opacity: 0.9,
        }}
      >
        ⚠️ Please provide the Id parameter
      </Div>
    );
  }

  console.log("requests", requests);

  return (
    <>
      {WorkflowName === "TimesheetLog" ? (
        <DocumentApprovalForHrNew />
      ) : (
        <>
          <Div
            sx={{
              p: 5,
              backgroundColor: "#FFFFFF",
            }}
          >
            <ToastContainer autoClose={1000} />
            <Typography variant="h2">Document Approvals</Typography>
            <Typography variant="h4">
              Approvers shall use this form to approve or Reject documents
              received from users
            </Typography>

            <form onSubmit={(e) => handleSubmit(handleApproveRequest(e))}>
              <Div className="row" sx={{ mt: 1 }}>
                <Div className="col col-8">
                  {!isDataLoading ? (
                    <Grid container columns={12} sx={{ mt: 1 }}>
                      <Grid item xs={3}>
                        <Div>
                          <Typography variant="h5">Document Type</Typography>
                          {WorkflowName === "payroll management" ? (
                            <>
                              <Typography variant="h5">
                                Total Attendance
                              </Typography>
                              <Typography variant="h5">Total Salary</Typography>
                            </>
                          ) : WorkflowName === "Attandance Management" ? (
                            <>
                              <Typography variant="h5">
                                Total Employees
                              </Typography>
                              <Typography variant="h5">
                                Total Attendance
                              </Typography>
                              <Typography variant="h5">Month</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="h5">Request No #</Typography>
                              <Typography variant="h5">
                                Initiated by user
                              </Typography>
                            </>
                          )}
                        </Div>
                      </Grid>
                      <Grid item xs={1}>
                        <Div>
                          {WorkflowName === "Attandance Management" ? (
                            <>
                              <Typography variant="h5"> : </Typography>
                              <Typography variant="h5"> : </Typography>
                              <Typography variant="h5"> : </Typography>
                              <Typography variant="h5"> : </Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="h5"> : </Typography>
                              <Typography variant="h5"> : </Typography>
                              <Typography variant="h5"> : </Typography>
                            </>
                          )}
                        </Div>
                      </Grid>
                      <Grid item xs={8}>
                        <Div>
                          <Typography variant="h5">
                            {FirstLetterCaps(WorkflowName) || ""}
                          </Typography>
                          {WorkflowName === "payroll management" ? (
                            <>
                              <Typography variant="h5">
                                {requests && requests?.length}
                              </Typography>
                              <Typography variant="h5">
                                {requests?.length > 0
                                  ? formatIndianNumber(
                                    requests.reduce(
                                      (sum, opt) =>
                                        sum +
                                        (Math.round(
                                          opt?.Salary_Details
                                            ?.This_Month_Salary,
                                        ) || 0),
                                      0,
                                    ),
                                  )
                                  : ""}

                                {/* {requests && requests ?  requests?.map((opt) => opt?.Salary_Details?.This_Month_Salary)?.reduce((a, b) => a + b, 0)?.toFixed(0) : ""} */}
                              </Typography>
                            </>
                          ) : WorkflowName === "Attandance Management" ? (
                            <>
                              <Typography variant="h5">
                                {employeeLists && employeeLists?.count}
                              </Typography>
                              <Typography variant="h5">
                                {requests && requests?.length}
                              </Typography>
                              <Typography variant="h5">
                                {/* {
                            requests && requests.length ?
                              requests.map((opt) => opt.This_Month_Salary)
                                .reduce((a, b) => a + b, 0)
                                .toFixed(0)
                              : ""
                          } */}
                                {Array.isArray(requests) && requests[0]?.Month}
                              </Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="h5">
                                {WorkflowName === "Leave"
                                  ? requests?.Application_Id || ""
                                  : WorkflowName === "Leave Cancellation"
                                    ? requests?.Cancellation_Id || ""
                                    : WorkflowName === "timesheet"
                                      ? requests?.TimeSheet_Id || ""
                                      : WorkflowName === "Reimbursement"
                                        ? requests?.Employeeclaim_Id || ""
                                        : WorkflowName ===
                                          "Full and Final Settlement"
                                          ? requests?.FullandFinal_Id || ""
                                          : WorkflowName === "Resignation"
                                            ? requests?.EmployeeResignation_Id ||
                                            ""
                                            : WorkflowName ===
                                              "Attandance Management"
                                              ? requests
                                                ?.map(
                                                  (opt) => opt?.Employee_Id,
                                                )
                                                .join(",") || ""
                                              : WorkflowName ===
                                                "payroll management"
                                                ? requests
                                                  .map(
                                                    (opt) => opt?.Payslip_Id,
                                                  )
                                                  .join(",") || ""
                                                : "-"}
                              </Typography>
                              <Typography variant="h5">
                                {WorkflowName === "payroll management" ? (
                                  <>
                                    {requests
                                      ?.map((opt) => opt?.Employee_Name)
                                      .join(",")}{" "}
                                    {/* <span> - {requests?.map((opt) => opt?.Designation).join(",")}</span> */}
                                  </>
                                ) : WorkflowName ===
                                  "Full and Final Settlement" ? (
                                  <>
                                    {requests?.Employee_Name}{" "}
                                    <span> - {requests?.Employee_Id}</span>
                                    {/* <span> - {requests?.Created_By?.Designation}</span> */}
                                  </>
                                ) : (
                                  <>
                                    {getInitiatorName()}
                                    {requests?.Employee_Id?.Employee_Id ? (
                                      <span>
                                        {" "}
                                        -{" "}
                                        {requests?.Employee_Id?.Employee_Id ||
                                          requests?.Employee_Id}
                                      </span>
                                    ) : requests?.Created_By?.Employee_Id ? (
                                      <span>
                                        {" "}
                                        - {requests?.Created_By?.Employee_Id}
                                      </span>
                                    ) : (
                                      <span> - {requests?.Employee_Id}</span>
                                    )}
                                    {/* <span> - {requests?.Created_By?.Designation}</span> */}
                                  </>
                                )}
                              </Typography>
                            </>
                          )}
                        </Div>
                      </Grid>
                    </Grid>
                  ) : (
                    <Div
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </Div>
                  )}
                </Div>

                <Div className="col col-4">
                  {/* {WorkflowName === "payroll management" ? (
                <></>
              ) : WorkflowName === "Attandance Management" ? (
                <></>
              ) : ( */}
                  <Div sx={{ textAlign: "end", mt: 2, mr: 9.5 }}>
                    <ErpSaveUpdateButton
                      name={"View Document"}
                      onClick={() => setOpenViewRequest(true)}
                      icon={<AiFillEye size={18} />}
                      width={"200px !important"}
                    />
                  </Div>
                  {/* )} */}
                </Div>

                <Div className="row" sx={{ mt: 3, minWidth: "400px" }}>
                  <Div className="col-12 d-flex ps-0">
                    {approvalStatus?.Approve?.length > 0 ? (
                      approvalStatus?.Approve?.map((data, inx) => {
                        console.log("data.Approved_flg", data.Approved_flg);
                        // console.log("approvalStatus.length", approvalStatus[0]);

                        return (
                          <>
                            <Grid container xs={2} key={inx}>
                              <Grid
                                item
                                xs={9}
                                md={10}
                              // className="col-sm-6 col-md-3 col-lg-2"
                              >
                                <Card
                                  className="card"
                                  sx={{
                                    p: 1.5,
                                    boxShadow: "none",
                                    height: "140px",
                                  }}
                                >
                                  <Typography
                                    variant="h4"
                                    textAlign={"center"}
                                    sx={{ height: "40px" }}
                                  >
                                    {data?.Approvername}
                                  </Typography>

                                  <Card
                                    className="card"
                                    sx={{
                                      p: 0,
                                      pt: 1,
                                      boxShadow: "none",
                                      // backgroundColor: "#017890",
                                      // color: "#FFFFFF",
                                      border: "none",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <Typography
                                      variant="h5"
                                      textAlign={"center"}
                                      // color={"#FFFFFF"}
                                      color={"#000000"}
                                      fontWeight={500}
                                      sx={{ height: "40px" }}
                                    >
                                      {data?.ApproverRole}
                                    </Typography>
                                  </Card>
                                  {/* <br /> */}

                                  {data?.Approved_flg === true ? (
                                    <Typography
                                      variant="text"
                                      color="success"
                                      sx={{
                                        // width: "110px",
                                        cursor: "default",
                                        color: "#3BD2A2",
                                        textAlign: "center",
                                      }}
                                    >
                                      Approved
                                    </Typography>
                                  ) : (
                                    <Typography
                                      variant="text"
                                      color="warning"
                                      textAlign={"center"}
                                      sx={{
                                        // width: "110px",
                                        cursor: "default",
                                        color: "#F39711",
                                        textAlign: "center",
                                      }}
                                    >
                                      Pending
                                    </Typography>
                                  )}
                                </Card>
                              </Grid>
                              <Grid
                                item
                                xs={3}
                                md={2}
                                // className="col-sm-3 col-md-2 col-lg-1"
                                sx={{
                                  display:
                                    approvalStatus?.Approve?.length === inx + 1
                                      ? "none"
                                      : "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Div
                                  sx={{
                                    width: "80px",
                                    height: "1px",
                                    borderBottom: "1px solid #8F8F8F",
                                  }}
                                ></Div>
                                <span>{`>`}</span>
                              </Grid>
                            </Grid>
                          </>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Div>
                </Div>

                <Div className="row mt-3">
                  <Div className="col-6">
                    {!isApprovalLoading ? (
                      approvals?.map((option, index) => {
                        const { comments, status_btn } = option;
                        console.log("Approvername", index, number);
                        return (
                          <Div
                            key={index}
                            sx={{
                              mt: 1.5,
                              display: index === number ? "block" : "none",
                            }}
                          >
                            <Typography variant="h5">
                              Approve <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <Div>
                              <FormControlLabel
                                control={
                                  <Radio
                                    color="primary"
                                    size="small"
                                    name="status_btn"
                                    value="yes"
                                    {...register("status_btn")}
                                    checked={status_btn === "yes"}
                                    // onChange={(e) => {
                                    //   setCheckApproved(e.target.value);
                                    // }}
                                    onChange={(e) =>
                                      handleChangeApproverRequest(e, index)
                                    }
                                  />
                                }
                                label="Yes"
                              />

                              <FormControlLabel
                                control={
                                  <Radio
                                    color="primary"
                                    size="small"
                                    name="status_btn"
                                    value="no"
                                    {...register("status_btn")}
                                    checked={status_btn === "no"}
                                    // onChange={(e) => {
                                    //   console.log("hdf", e);
                                    //   setCheckApproved(e.target.value);
                                    // }}
                                    onChange={(e) =>
                                      handleChangeApproverRequest(e, index)
                                    }
                                  />
                                }
                                label="No"
                              />
                              <Div style={{ color: "red" }}>
                                {errors.status_btn?.message}
                              </Div>
                            </Div>

                            <Div className="row" sx={{ mt: 1 }}>
                              <Typography
                                variant="h5"
                                className="col-12 input-label"
                              >
                                Enter your Comments{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Typography>
                              <Div className="col-12">
                                <TextField
                                  className={`col-12 multiline-box ${errors.comments ? "is-invalid" : ""
                                    }`}
                                  rows={4}
                                  multiline
                                  name="comments"
                                  // {...register("comments")}
                                  value={comments}
                                  // onChange={(e) => setCommentOfApprover(e.target.value)}
                                  onChange={(e) =>
                                    handleChangeApproverCommentRequest(e, index)
                                  }
                                  placeholder="Enter your Comments here..."
                                />
                                <Div style={{ color: "red" }}>
                                  {/* {errors.comments?.message} */}
                                </Div>
                              </Div>
                            </Div>
                          </Div>
                        );
                      })
                    ) : (
                      <Div
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CircularProgress />
                      </Div>
                    )}
                  </Div>
                  <Div className="col-md-4"></Div>
                  <Div
                    className="col-md-2"
                    sx={{
                      display: "flex",
                      alignItems: "end",
                      justifyContent: "center",
                    }}
                  >
                    {approvalStatus?.Approve?.length > 0 &&
                      approvalStatus?.Approve[number]?.OneTimeApproved_flg ===
                      true ? (
                      ""
                    ) : (
                      <Div aria-label="split button" sx={{ mr: 3 }}>
                        <ErpSaveUpdateButton
                          name={"Submit"}
                          type="submit"
                          loading={isLoading}
                          disabled={isLoading}
                          width={"100px !important"}
                        />
                      </Div>
                    )}
                  </Div>
                </Div>
              </Div>
            </form>
          </Div>

          {/* overview page of request material */}

          <Div>
            {WorkflowName === "Leave" ? (
              <LeaveDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : WorkflowName === "Leave Cancellation" ? (
              <LeaveCancellationDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : WorkflowName === "timesheet" ? (
              <TimeManagementDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : WorkflowName === "Reimbursement" ? (
              <ClaimDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : WorkflowName === "Resignation" ? (
              <ResignationDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : WorkflowName === "Attandance Management" ? (
              <AttendanceDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                requests={requests}
                setRequests={setRequests}
                setCloseRequest={setCloseRequest}
              />
            ) : WorkflowName === "payroll management" ? (
              <PayslipDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                requests={requests}
                setRequests={setRequests}
                setCloseRequest={setCloseRequest}
              />
            ) : WorkflowName === "Full and Final Settlement" ? (
              <SettlementDocumentApproval
                openViewRequest={openViewRequest}
                setOpenViewRequest={setOpenViewRequest}
                value={value}
                handleChange={handleChange}
                requests={requests}
                setRequests={setRequests}
                approvalStatus={approvalStatus}
                updateHistory={updateHistory}
              />
            ) : (
              <></>
            )}
          </Div>
        </>
      )}
    </>
  );
};

export default DocumentApprovalForHr;
